// frontend/src/components/common/Logo.jsx
import React from 'react';

const sizes = { sm: 'h-12', md: 'h-20', lg: 'h-64', xl: 'max-h-[420px]' };

export default function Logo({ size = 'md', className = '' }) {
  return (
    <img
      src="/STB_LOGO_V1.png"
      alt="SecureTheBag Logo"
      className={`${sizes[size] || sizes.md} w-auto object-contain ${className}`}
    />
  );
}
